import React, { createContext, useMemo, useState } from "react";

interface LoadingAnimationContextData {
    hasLoadedOnce: boolean;
    alsoGoingOutHasLoadedOnce: boolean;

    setHasLoadedOnce: (value: boolean) => void;
    setAlsoGoingOutHasLoadedOnce: (value: boolean) => void;
}

export const LoadingAnimationContext = createContext<LoadingAnimationContextData>({
    hasLoadedOnce: false,
    alsoGoingOutHasLoadedOnce: false,

    setHasLoadedOnce: () => { },
    setAlsoGoingOutHasLoadedOnce: () => { }
});

export const LoadingAnimationProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [hasLoadedOnce, setHasLoadedOnce] = useState<boolean>(false);
    const [alsoGoingOutHasLoadedOnce, setAlsoGoingOutHasLoadedOnce] = useState<boolean>(false);

    const value = useMemo(() => ({ hasLoadedOnce, alsoGoingOutHasLoadedOnce, setHasLoadedOnce, setAlsoGoingOutHasLoadedOnce }), [hasLoadedOnce, alsoGoingOutHasLoadedOnce]);

    return (
        <LoadingAnimationContext.Provider value={value}>
            {children}
        </LoadingAnimationContext.Provider>
    );
};
